/* Draft-only Stopper redemption. Shopify remains the discount authority. */
(function (scope, factory) {
  var api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  if (scope && scope.document) api.mount(scope);
})(typeof window === 'undefined' ? null : window, function () {
  'use strict';
  function validCode(code) { return /^NONSTOP-[A-Z0-9]{6,32}$/.test(String(code || '')); }
  function codes(cart) {
    var found = [];
    function add(code) { if (code && !found.some(function (c) { return c.toUpperCase() === code.toUpperCase(); })) found.push(code); }
    (cart.discount_codes || []).forEach(function (d) { add(d.code); });
    var apps = (cart.cart_level_discount_applications || []).slice();
    (cart.items || []).forEach(function (i) { (i.line_level_discount_allocations || []).forEach(function (a) { apps.push(a.discount_application || {}); }); });
    apps.forEach(function (a) { if (a.type === 'discount_code') add(a.title); });
    return found;
  }
  function stopperItems(cart, id) { return (cart.items || []).filter(function (i) { return String(i.variant_id) === String(id); }); }
  function verified(cart, id, code) {
    return stopperItems(cart, id).some(function (i) {
      return (i.line_level_discount_allocations || []).some(function (a) {
        return String((a.discount_application || {}).title).toUpperCase() === code && Number(a.amount) >= Number(i.original_price || i.price) && Number(i.original_price || i.price) > 0;
      });
    });
  }
  async function redeem(client, id, code) {
    code = String(code || '').toUpperCase();
    if (!validCode(code) || !/^\d+$/.test(String(id))) throw new Error('Invalid prize link. Please use the link in your prize email.');
    var before = await client.get(), previous = codes(before), added = false, attempted = false;
    try {
      if (!stopperItems(before, id).length) { added = true; await client.add(id); }
      var combined = previous.filter(function (c) { return c.toUpperCase() !== code; }).concat(code);
      attempted = true;
      await client.discount(combined.join(','));
      var after = await client.get();
      if (!verified(after, id, code)) throw new Error('Your Stopper could not be confirmed free. Use your winning email at checkout, or contact us before ordering.');
      return { cart: after, added: added };
    } catch (error) {
      // Remove only the single unit this attempt added, never a customer's existing item.
      var rollbackFailed = false;
      if (added) {
        try {
          var current = await client.get(), items = stopperItems(current, id);
          if (items.reduce(function (n, i) { return n + i.quantity; }, 0) === 1) await client.remove(items[0].key);
          else if (items.length) rollbackFailed = true;
        } catch (_) { rollbackFailed = true; }
      }
      if (attempted) { try { await client.discount(previous.join(',')); } catch (_) { rollbackFailed = true; } }
      if (rollbackFailed) throw new Error('We could not finish redemption. Check your cart and remove any paid Stopper before ordering. Your bottles have not been changed.');
      throw error;
    }
  }
  function mount(win) {
    var doc = win.document, root = (win.Shopify && win.Shopify.routes && win.Shopify.routes.root) || '/', pending;
    async function request(path, body) {
      var response = await win.fetch(root + path, { method: body ? 'POST' : 'GET', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' }, body: body ? JSON.stringify(body) : undefined });
      var data = await response.json();
      if (!response.ok) throw new Error(data.description || 'Could not update your cart. Please try again.');
      return data;
    }
    var client = { get: function () { return request('cart.js'); }, add: function (id) { return request('cart/add.js', { items: [{ id: Number(id), quantity: 1 }] }); }, discount: function (value) { return request('cart/update.js', { discount: value }); }, remove: function (key) { return request('cart/change.js', { id: key, quantity: 0 }); } };
    function panel() {
      var el = doc.getElementById('non-stopper-redemption');
      if (!el) {
        el = doc.createElement('section'); el.id = 'non-stopper-redemption'; el.className = 'non-stopper-redemption'; el.setAttribute('role', 'status'); el.setAttribute('aria-live', 'polite');
        var main = doc.getElementById('MainContent') || doc.querySelector('main') || doc.body; main.insertBefore(el, main.firstChild);
      }
      return el;
    }
    function run() {
      var url = new URL(win.location.href), code = url.searchParams.get('non_lotto_stopper');
      if (!code || pending || !url.pathname.replace(/\/$/, '').endsWith('/cart')) return;
      var config = doc.querySelector('[data-non-stopper-variant]'), id = config && config.getAttribute('data-non-stopper-variant'), el = panel();
      el.textContent = 'Adding your free Stopper…';
      var action = function () { return redeem(client, id, code); };
      pending = (win.navigator.locks ? win.navigator.locks.request('non-lotto-stopper', action) : action()).then(function () {
        el.textContent = 'Stopper added. Check the Lotto email requirement beside your Stopper before paying.';
        url.searchParams.delete('non_lotto_stopper'); win.history.replaceState(null, '', url.pathname + url.search + url.hash);
        // A single reload lets the theme render Shopify's updated cart, not stale drawer markup.
        try { win.sessionStorage.setItem('non-stopper-confirmed', '1'); } catch (_) {}
        win.location.reload();
      }).catch(function (error) { el.textContent = error.message; pending = null; });
    }
    function ready() {
      var confirmed = false;
      try { confirmed = win.sessionStorage.getItem('non-stopper-confirmed'); win.sessionStorage.removeItem('non-stopper-confirmed'); } catch (_) {}
      if (win.location.pathname.replace(/\/$/, '').endsWith('/cart') && confirmed) {
        // Do not repeat a stale success claim if the cart changed during reload.
        client.get().then(function (cart) {
          var config = doc.querySelector('[data-non-stopper-variant]'), id = config && config.getAttribute('data-non-stopper-variant');
          if (codes(cart).some(function (c) { return validCode(c.toUpperCase()) && verified(cart, id, c.toUpperCase()); })) panel().textContent = 'Stopper added. Check the Lotto email requirement beside your Stopper before paying.';
        }).catch(function () {});
      }
      run();
    }
    if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', ready); else ready();
  }
  return { redeem: redeem, codes: codes, verified: verified, validCode: validCode, mount: mount };
});
